import { render, staticRenderFns } from "./ChartTransactionCount.vue?vue&type=template&id=31dcff00"
import script from "./ChartTransactionCount.vue?vue&type=script&lang=js"
export * from "./ChartTransactionCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports